var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
import { html } from 'lit';
import { cache } from 'lit-html/directives/cache.js';
import { sdsCustomElement } from '../utilities/custom-components';
import styles from './sds-clipped-text.lit.scss';
import { SdsClippedTextBase } from './_sds-clipped-text-base.lit';
import { ifDefined } from 'lit-html/directives/if-defined.js';
/**
 * The `SdsClippedText` component provides a mechanism to display text that,
 * if it overflows its container, will show the full text in a tooltip.
 *
 * @tag sds-clipped-text
 *
 * @example
 * ```html
 * <sds-clipped-text text="This is some text that will be clipped if it overflows its container."></sds-clipped-text>
 * ```
 *
 */
let SdsClippedText = (() => {
    let _classDecorators = [sdsCustomElement('sds-clipped-text')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsClippedTextBase;
    var SdsClippedText = _classThis = class extends _classSuper {
        render() {
            return html ` ${cache(this.hasOverflow ? this.renderClipped() : this.renderUnclipped())} `;
        }
        renderClipped() {
            return html `
            <sds-tooltip position="up" basic=${ifDefined(this.basic ? true : undefined)}>
                ${this.text}
                <div
                    slot="trigger"
                    class="sds-clipped-container"
                    part="sds-clipped-text"
                    aria-hidden="true"
                >
                    <slot></slot>
                    <div
                        data-id="text-container"
                        class="sds-clipped-text ${this.lines > 1
                ? 'sds-clipped-text--multiline'
                : ''}"
                    >
                        ${this.renderContent()}
                    </div>
                </div>
            </sds-tooltip>
        `;
        }
        renderUnclipped() {
            return html `
            <div class="sds-clipped-container" part="sds-clipped-text">
                <slot></slot>
                <div
                    data-id="text-container"
                    class="sds-clipped-text ${this.lines > 1 ? 'sds-clipped-text--multiline' : ''}"
                >
                    ${this.renderContent()}
                </div>
            </div>
        `;
        }
    };
    __setFunctionName(_classThis, "SdsClippedText");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsClippedText = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsClippedText = _classThis;
})();
export { SdsClippedText };
